import { apiCall } from './generated/gqlClient';

const deleteInactiveSessionsApiRequest = async classId => {
  const mutation = `
    mutation deleteInactiveSessions($classId: Int!) {
      deleteInactiveSessions(classId: $classId) {
        id
        success
        message
      }
    }
  `;

  return apiCall({ query: mutation, variables: { classId: +classId } });
};

export { deleteInactiveSessionsApiRequest };
